import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { BookOpen, Quote, MessageSquare, FileText } from 'lucide-react';

const StorytellingSection = ({ toolkit }) => {
  const refrains = toolkit.storytelling.localRefrains;
  const examples = toolkit.storytelling.exampleStories;
  
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center">
          <BookOpen className="w-6 h-6 text-amber-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Storytelling Guide</h2>
          <p className="text-gray-600">Local refrains, tone guidance, and story examples</p>
        </div>
      </div>

      <Card className="border-2 border-amber-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Quote className="w-5 h-5 text-amber-700" />
            Local Refrains & Sayings
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {refrains.map((refrain, idx) => (
            <div key={idx} className="flex items-start gap-3 p-4 bg-amber-50 rounded-lg border border-amber-200">
              <Quote className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
              <p className="text-amber-900 font-medium italic">{refrain}</p>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-2 border-green-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-green-700" />
            Tone & Voice Guidance
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-700 leading-relaxed">{toolkit.storytelling.toneGuidance}</p>
        </CardContent>
      </Card>

      <Card className="border-2 border-blue-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-blue-700" />
            Example Story Ideas
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-3 gap-4">
            {examples.map((story, idx) => (
              <div key={idx} className="p-4 bg-white rounded-lg border border-gray-200 hover:border-green-300 transition-colors">
                <h5 className="font-bold text-gray-900 mb-1">{story.title}</h5>
                <p className="text-sm text-gray-600">{story.theme}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default StorytellingSection;
